module.exports = Function.call.bind(Object.prototype.hasOwnProperty);



//////////////////
// WEBPACK FOOTER
// ./~/_prop-types@15.8.1@prop-types/lib/has.js
// module id = 1615
// module chunks = 0